import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Button, CircularProgress, Menu, MenuItem } from "@mui/material";
import "jspdf-autotable";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { fetchLatestBidAwardLogsByReferenceNumber } from "../../api/bid";
import { exportToCsv, generateExportedFilename } from "../../util/bid/bidAwardExport";
import FreedayBidPDFExport from "../../pages/bid/FreedayBidPDFExport";

const FreedayBidAwardExport = (props) => {
  const [exportLoading, setExportLoading] = useState(false);
  const handleExportBtnClick = (event) => {
    props.setExportResultsMenuAnchor(event.currentTarget);
  };

  const handleExportBtnClose = () => {
    props.setExportResultsMenuAnchor(null);
  };

  const handleCsvMenuItemClick = async () => {
    try {
      exportToCsv({
        filename: generateExportedFilename({
          station: props.bid.station,
          workgroup: props.bid.workgroup,
          bidType: props.bid.bidType,
          effectiveStartDate: props.bid.schedStartDate,
          effectiveEndDate: props.bid.schedEndDate,
          schedMonth: props.schedMonth,
          schedYear: props.schedYear,
        }),
        rows: props.bidAllotments,
        bidType: props.bid.bidType,
      });
      handleExportBtnClose();
    } catch (e) {
      console.error("Error during downloading csv!");
    }
  };

  const downloadZipFile = (url, fileName) => {
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleAwardLogItemClick = () => {
    setExportLoading(true);
    fetchLatestBidAwardLogsByReferenceNumber(props.bid.referenceNumber)
      .then((res) => res.json())
      .then((response) => {
        if (response.body) {
          downloadZipFile(response.body.downloadUrl, response.body.fileName);
        } else {
          throw Error();
        }
        setExportLoading(false);
      })
      .catch((err) => {
        console.error(`Bid Error: %j`, err);
        setExportLoading(false);
      });
  };

  return (
    <>
      <Button
        data-testid="bidAward-export-button"
        variant="outlined"
        color="primary"
        size="medium"
        onClick={handleExportBtnClick}
        startIcon={exportLoading ? <CircularProgress size={20} /> : <UploadFileIcon />}
      >
        Export Results
      </Button>
      <Menu
        data-testid="bidAward-export-menu"
        anchorEl={props.exportResultsMenuAnchor}
        open={!!props.exportResultsMenuAnchor}
        onClose={handleExportBtnClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={() => handleCsvMenuItemClick(props.bid)}>Admin CSV</MenuItem>
        <MenuItem disabled={exportLoading || props.isFormChanged} onClick={() => handleAwardLogItemClick()}>
          Award Log
        </MenuItem>
        <FreedayBidPDFExport
          bidChoiceData={props.bid}
          bidAllotments={props.bidAllotments}
          isAdminAwardExport={true}
          onExportMenuClose={handleExportBtnClose}
          calcStandardAllotments={props.calcStandardAllotments}
          calcReliefAllotments={props.calcReliefAllotments}
        />
      </Menu>
    </>
  );
};

FreedayBidAwardExport.propTypes = {
  bid: PropTypes.object.isRequired,
  bidAllotments: PropTypes.array.isRequired,
  exportResultsMenuAnchor: PropTypes.object,
  setExportResultsMenuAnchor: PropTypes.func.isRequired,
  isFormChanged: PropTypes.bool.isRequired,
  schedMonth: PropTypes.string,
  schedYear: PropTypes.string,
  calcStandardAllotments: PropTypes.object,
  calcReliefAllotments: PropTypes.object,
};

export default FreedayBidAwardExport;
